import { useUser } from '~/@biz_account/useUser/useUser'
import { InvestorAnalysis } from './InvestorAnalysis'

function InvestorAnalysisContent() {
  const { reloadUser } = useUser()
  return <InvestorAnalysis onAnalysisCompleted={reloadUser} />
}

export { InvestorAnalysisContent }
